import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/termometre.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';
import Sensors from './Sensors';
import AddSensor from './AddSensor';

import { BlueTickIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleSummit, ok, handleDelete, id, handleRegister) {
    const deleteButton = id ? (
        <TrashIcon
            key="delete-post-termometre"
            className="hand"
            color="secondary"
            onClick={handleDelete}
        />
    ) : null;
    return [
        <BlueTickIcon
            disabled={!ok}
            key="submmit-post-termometre"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />,
        deleteButton,
    ];
}

class Termometre extends React.Component {
    state = {
        id: randomstring(),
        tipo: 'COOPER',
        gatewayID: '',
        nombre: '',
        mac: '',
        idLocal: undefined,
        error: '',
        errorType: undefined,
        add: false,
        sensores: [],
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.getTermometre(props.id);
        }
    }

    componentDidUpdate() {
        const tools = toolbar(
            this.handleSummit,
            this.isCorrect(),
            this.handleDelete,
            this.props.id,
            this.handleRegister,
        );
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.termometre && nextProps.id) {
            const { id, tipo, gatewayID, nombre, mac, idLocal, sensores } = nextProps.termometre;
            this.setState({
                id: id,
                tipo: tipo ? tipo : 'COOPER',
                gatewayID: gatewayID ? gatewayID : '',
                nombre: nombre ? nombre : '',
                idLocal: idLocal ? idLocal : '',
                sensores: sensores ? sensores : [],
                mac: mac ? mac : '',
            });
        }
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    isCorrect = () => {
        const { gatewayID, mac, nombre, idLocal } = this.state;
        return gatewayID && mac && nombre && idLocal;
    };

    handleDelete = () => {
        const { intl } = this.props;
        const r = window.confirm(intl.formatMessage({ id: 'delete_message_confirm' }));
        if (r === true) {
            this.props
                .remove(this.props.id)
                .then((r) => {
                    this.props.history.push('/manage/termometres');
                })
                .catch((error) => {
                    this.setState({ error: error.message });
                });
        }
    };

    handleEdit = (sensor) => {
        this.setState({ add: true, temp: sensor });
    };

    handleAddSensor = () => {
        this.setState({ add: true });
    };

    handleCloseDialog = (name, code, id, fields) => {
        if (name) {
            const { sensores } = this.state;

            const sensor = {
                nombre: name,
                sensorCode: code,
                sensorId: id,
                campos: fields,
                tipo: 'TEMPERATURA',
            };

            if (this.state.temp) {
                const index = sensores.map((s) => s.nombre).indexOf(name);
                sensores.splice(index, 1);
                sensor.id = this.state.temp.id;
            }
            sensores.push(sensor);
            this.setState({ sensores: sensores, add: false, temp: undefined });
        } else {
            this.setState({ add: false, temp: undefined });
        }
    };

    handleDeleteSensor = (sensor) => {
        const { sensores } = this.state;
        const index = sensores.indexOf(sensor);
        sensores.splice(index, 1);
        this.setState({ sensores: sensores });
    };

    handleSummit = () => {
        const { id, tipo, gatewayID, nombre, idLocal, mac, sensores } = this.state;
        const termometre = {
            tipo: tipo,
            gatewayID: gatewayID,
            nombre: nombre,
            idLocal: parseInt(idLocal, 10),
            mac: mac,
            sensores: sensores,
        };
        if (!this.props.id) {
            this.props
                .add(termometre)
                .then((r) => {
                    this.props.history.push('/manage/termometres');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            termometre.id = id;
            this.props
                .edit(termometre)
                .then((r) => {
                    this.props.history.push('/manage/termometres');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    Field = (field, name, intl, autoFocus = false, disable = false) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            margin="normal"
        />
    );

    render() {
        const { add, tipo, gatewayID, nombre, idLocal, mac, sensores, error, errorType, temp } = this.state;
        const { intl, id, termometres_is_loading, termometres_has_errored, info } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && termometres_has_errored.hasErrored) {
            return (
                <Error open type={termometres_has_errored.hasErrored}  message={termometres_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            const nodes = info.security.locals;
            const errorMac = mac
                ? !/^(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[,]?)+$/.test(mac)
                : false;
            return (
                <div className={'flex_full_row bg_white'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    {termometres_is_loading && <Loading open opacity />}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll showbar "
                                onScroll={this.handleScroll}
                            >
                                <div className="flex_full_column margin_top_18 padding_borders">
                                    {this.Field(tipo, 'tipo', intl, false, true)}
                                    {this.Field(
                                        nombre,
                                        'nombre',
                                        intl,
                                        true,
                                        this.props.id !== undefined,
                                    )}
                                    <TextField
                                        fullWidth
                                        id={'mac'}
                                        name={'mac'}
                                        required
                                        disabled={this.props.id !== undefined}
                                        error={errorMac}
                                        helperText={
                                            mac && errorMac
                                                ? intl.formatMessage({ id: 'error_format_mac' })
                                                : ''
                                        }
                                        label={intl.formatMessage({ id: 'form_field_name_mac' })}
                                        className={'flex_full_row'}
                                        value={mac}
                                        onChange={this.handleChange}
                                        margin="normal"
                                    />
                                    {this.Field(
                                        gatewayID,
                                        'gatewayID',
                                        intl,
                                        false,
                                        this.props.id !== undefined,
                                    )}
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <FormControl
                                            className={'flex_full width100 barlow_italic c_slate'}
                                            disabled={this.props.id !== undefined}
                                        >
                                            <InputLabel htmlFor="idLocal" shrink>
                                                {intl.formatMessage({ id: 'type_label_local' })}
                                            </InputLabel>
                                            <Select
                                                native
                                                name={'idLocal'}
                                                id={'idLocal'}
                                                value={idLocal}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'idLocal', id: 'idLocal' }}
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {nodes &&
                                                    nodes.map((cat) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={cat.id}
                                                            >
                                                                {cat.name}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <Sensors
                                        sensores={sensores}
                                        onAdd={this.handleAddSensor.bind(this)}
                                        onDelete={this.handleDeleteSensor.bind(this)}
                                        onEdit={this.handleEdit.bind(this)}
                                        local={idLocal}
                                    />
                                </div>
                            </div>
                        </div>
                        {add && (
                            <AddSensor
                                handleClose={this.handleCloseDialog.bind(this)}
                                local={idLocal}
                                sensor={temp}
                            />
                        )}
                    </div>
                </div>
            );
        }
    }
}

Termometre.propTypes = {
    intl: intlShape.isRequired,
    termometre: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    termometres_has_errored: PropTypes.object.isRequired,
    termometres_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        termometres_has_errored: state.termometres_has_errored,
        termometres_is_loading: state.termometres_is_loading,
        termometre: state.termometre,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(withRouter(Termometre)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometre/Index.js